import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forums-comments',
  templateUrl: './forums-comments.component.html',
  styleUrls: ['./forums-comments.component.css'],
  standalone: false,
})
export class ForumsCommentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
